module.exports = __webpack_public_path__ + "assets/img/license.a9d8236d.png";